<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="update-deduction"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >update occupation</small
                >
              </legend>
              <form @submit.prevent="updateDeduction()">
                <div class="row">
                  <input type="hidden" class="id" :value="Deduction.id" />
                  <input
                    type="hidden"
                    class="Uemployee_id"
                    :value="Deduction.employee_id"
                  />
                  <div class="col-md-6">
                    <div class="form-group" v-if="Deduction.load_penalty > 0">
                      <label>Loan/Penalty</label>
                      <input
                        type="number"
                        min="0"
                        id="U_load_penalty"
                        class="noscroll form-control Uload_penalty"
                        :value="Deduction.load_penalty"
                        readonly
                      />
                    </div>
                    <div class="form-group" v-else>
                      <label>Loan/Penalty</label>
                      <input
                        id="U_load_penalty"
                        type="number"
                        min="0"
                        class="noscroll form-control Uload_penalty"
                        :value="Deduction.load_penalty"
                        @keyup="calculateUpdate()"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group" v-if="Deduction.deductions > 0">
                      <label>Deduction</label>
                      <input
                        type="number"
                        id="U_deductions"
                        min="0"
                        :value="Deduction.deductions"
                        class="noscroll form-control Udeductions"
                        readonly
                      />
                    </div>
                    <div class="form-group" v-else>
                      <label>Deduction</label>
                      <input
                        type="number"
                        id="U_deductions"
                        min="0"
                        :value="Deduction.deductions"
                        class="noscroll form-control Udeductions"
                        @keyup="calculateUpdate()"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group" v-if="Deduction.advance > 0">
                      <label>Advance</label>
                      <input
                        type="number"
                        id="U_advance"
                        min="0"
                        :value="Deduction.advance"
                        class="noscroll form-control Uadvance"
                        readonly
                      />
                    </div>
                    <div class="form-group" v-else>
                      <label>Advance</label>
                      <input
                        type="number"
                        min="0"
                        id="U_advance"
                        :value="Deduction.advance"
                        class="noscroll form-control Uadvance"
                        @keyup="calculateUpdate()"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Net pay</label>
                      <input
                        type="number"
                        readonly
                        id="U_deduction_pay"
                        :value="Deduction.deductions_pay"
                        class="form-control Udeduction_pay"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label>Remark</label>
                    <input
                      type="text"
                      class="form-control Uremark"
                      :value="Deduction.remark"
                    />
                  </div>
                </div>
                <p></p>
                <div></div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat updatingDeduction"
                >
                  <i class="fa fa-plus"></i> Update deduction
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat updatingDeductionLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
   
    <fieldset class="border p-3">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >Employeedeductions</small
        >
      </legend>
     
      <div>
        <form @submit.prevent="newDeduction()">
          <div class="row">
            <input type="hidden" class="employee_id" :value="Employee.id" />
            <div class="col-md-4">
              <label>Employee name</label>
              <input
                type="text"
                readonly
                class="form-control"
                :value="Employee.employee_name"
              />
            </div>
            <div class="col-md-4">
              <label>Occupation</label>
              <input
                type="text"
                readonly
                class="form-control"
                :value="Employee.occupation_name"
              />
            </div>
            <div class="col-md-4">
              <label>Salary</label>
              <input
                type="text"
                readonly
                id="salary"
                class="form-control salary"
                :value="Employee.salary"
              />
            </div>
          </div>
          <p></p>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Loan/Penalty</label>
                <input
                  id="load_penalty"
                  type="number"
                  min="0"
                  class="noscroll form-control load_penalty"
                  :value="0"
                  @keyup="calculate()"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Deduction</label>
                <input
                  type="number"
                  id="deductions"
                  min="0"
                  class="noscroll form-control deductions"
                  @keyup="calculate()"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Advance</label>
                <input
                  type="number"
                  min="0"
                  id="advance"
                  class="noscroll form-control advance"
                  @keyup="calculate()"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Net pay</label>
                <input
                  type="number"
                  readonly
                  id="deduction_pay"
                  class="form-control deduction_pay"
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat creatingDeduction"
          >
            <i class="fa fa-user"></i> add deductions
          </button>
          <button
            type="button"
            class="btn btn-info btn-flat creatingDeductionLoader"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i> please
            wait...
          </button>
        </form>
      </div>
      <p></p>
      <div>
        <vue-good-table
          :columns="columns"
          :rows="systemEmployeedeductions"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Edit'">
              <button
                class="btn btn-info btn-sm btn-block"
                @click="viewDeduction(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit deduction
              </button>
            </span>

            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import Vue from "vue";
export default {
  data() {
    return {
      columns: [
        {
          label: "Salary",
          field: "salary",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Penalty/Loan",
          field: "load_penalty",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Deductions",
          field: "deductions",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Advance",
          field: "advance",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Net pay",
          field: "deductions_pay",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
        {
          label: "Edit",
          field: "Edit",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
      payee: 0,
    };
  },
  created() {
    if (this.$store.getters.Employee.length === 0) {
      router.push("/manageemployees");
    }
  },
  computed: {
    ...mapGetters(["systemEmployeedeductions", "Employee", "Deduction"]),
  },
  methods: {
    ...mapActions(["newDeduction", "updateDeduction", "viewDeduction"]),
    calculate() {
      var penalty = document.getElementById("load_penalty").value;
      var loan = document.getElementById("deductions").value;
      var advances = document.getElementById("advance").value;
      var salary = document.getElementById("salary").value;
      var deduction_pay = salary;
      if (penalty.length > 0) {
        var total =
          (document.getElementById("deduction_pay").value =
          deduction_pay -=
            penalty);
        var total1 = (total -= loan);
     
        var percentage_total1 = total1 * 0.5;
        document.getElementById("deduction_pay").value = total1 -= advances;
        if (advances > percentage_total1) {
          Vue.swal.fire({
            title: "Advance ",
            text:
              "The total Advance is greater than 50% it should not be greater than " +
              percentage_total1,
            type: "warning",
          });
          $(".creatingDeduction").attr("disabled", true);
        } else {
          $(".creatingDeduction").attr("disabled", false);
        }
      }
    },
    calculateUpdate() {
      var penalty = document.getElementById("U_load_penalty").value;
      var loan = document.getElementById("U_deductions").value;
      var advances = document.getElementById("U_advance").value;
      var salary = this.$store.getters.Deduction.deductions_pay;
     
     if (penalty.readonly) {
        console.log('disabled');
     }else {
        var total = document.getElementById("U_deduction_pay").value =salary -= penalty;
        console.log(total);
     }

     
       
    //   console.log(loan);
    //   console.log(advances);
    },
  },
};
</script>
<style scoped>
.creatingDeductionLoader {
  display: none;
}
.updatingDeductionLoader {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/employeedeductions/deductions.vue